import * as focusTrap from 'focus-trap'
import $ from 'jquery'
import queryString from 'query-string'
import { debounce } from 'throttle-debounce'

const itemToLi = (item) => {
  let imageMarkup = ''
  if (item.image !== null) {
    imageMarkup = `
      <div class="image">
        <img src="${item.image}" alt="" />
      </div>
    `
  }
  let kickerMarkup = ''
  let subtitleMarkup = '<div class="subtitle"></div>'
  switch (item.type) {
    case 'article':
      subtitleMarkup = `<div class="subtitle">${item.date}</div>`
      if (item.article_types.length) {
        kickerMarkup = `
          <div class="kicker-wrap">
            <div class="kicker">
              ${item.article_types.join(' | ')}
            </div>
          </div>
        `
      }
      break
    case 'book':
      if (item.genre !== null) {
        kickerMarkup = `<div class="kicker-wrap"><div class="kicker">${item.genre}</div></div>`
      }
      if (item.authors_display) {
        subtitleMarkup = `
          <div class="subtitle">
            ${item.authors_display}
          </div>
        `
      } else if (item.authors.length) {
        subtitleMarkup = `
          <div class="subtitle">
            ${item.authors.join(' | ')}
          </div>
        `
      }
      break
    case 'event':
      kickerMarkup =
        '<div class="kicker-wrap"><div class="kicker">Event</div></div>'
      if (item.timing) {
        subtitleMarkup = `
          <div class="subtitle">
            ${item.timing}
          </div>
        `
      }
      break
    case 'page':
      kickerMarkup =
        '<div class="kicker-wrap"><div class="kicker">Page</div></div>'
      break
    case 'reading_list':
      if (item.cover_images.length) {
        imageMarkup = '<div class="image"><div class="covers">'
        imageMarkup += item.cover_images
          .map(
            (url, i) =>
              `<div class="cover cover-${i}" style="background-image:url(${url})"></div>`
          )
          .join('\n')
        imageMarkup += '</div></div>'
      }
      kickerMarkup =
        '<div class="kicker-wrap"><div class="kicker">Reading List</div></div>'
      break
    default:
      break
  }
  return `
    <li>
      <a href="${item.url}">
        ${imageMarkup}
        <div class="kicker-title-subtitle">
          ${kickerMarkup}
          <div class="title">${item.title}</div>
          ${subtitleMarkup}
        </div>
      </a>
    </li>
  `
}

class Search {
  constructor() {
    this.cache = {}
    this.contentType = null
    this.currentXhr = null
    this.isOpen = false
    this.keys = null
    this.page = 0
    this.trap = null
    this.$searchBody = $('.search-body')
    this.$searchContainer = $('.search-container')
    this.$searchButton = $('.search-sidebar button')
    this.$searchField = $('#search-field').val('')
    this.$searchPager = $('.search-pager')
    this.$searchResults = this.$searchBody.find('.search-results ul')
    this.$searchSpinner = $('.search-spinner')
    $('#search-trigger').on('click', this.handleClick)
  }
  close = () => {
    $(document).off('keyup', this.handleDocumentKeyup)
    this.$searchField.off('keyup', this.handleKeyup)
    this.$searchButton
      .removeClass('is-selected')
      .off('click', this.handleButtonClick)
    $('body').removeClass('search-is-open')
    this.$searchBody.removeClass('is-open')
    this.$searchContainer.removeClass('is-open')
    this.$searchPager.html('').find('a').off('click', this.handlePagerClick)
    this.$searchResults.html('')
    this.$searchField.val('')
    this.$searchSpinner.removeClass('is-searching')
    this.contentType = null
    this.currentXhr = null
    this.isOpen = false
    this.keys = null
    this.page = 0
    this.trap.deactivate()
    this.trap = null
  }
  doSearch = () => {
    const cacheKey = `${this.contentType}:${this.keys}:${this.page}`
    if (this.cache[cacheKey] !== undefined) {
      this.$searchResults.html('')
      if (this.cache[cacheKey].items.length) {
        this.cache[cacheKey].items.forEach((item) => {
          this.$searchResults.append(itemToLi(item))
        })
        this.$searchPager
          .html(this.cache[cacheKey].pager)
          .find('a')
          .on('click', this.handlePagerClick)
      } else {
        this.$searchResults.append('<li class="no-results">No results</li>')
        this.$searchPager.html('').find('a').off('click', this.handlePagerClick)
      }
    } else {
      if (this.currentXhr !== null) {
        this.currentXhr.abort()
      }
      this.$searchSpinner.addClass('is-searching')
      this.currentXhr = $.ajax({
        data: {
          content_type: this.contentType,
          keys: this.keys,
          page: this.page,
        },
        url: '/api/search',
      }).done((response) => {
        this.$searchResults.html('')
        this.cache[cacheKey] = {
          items: response.items,
          pager: response.pager,
        }
        if (response.items.length) {
          response.items.forEach((item) => {
            this.$searchResults.append(itemToLi(item))
          })
          this.$searchPager
            .html(response.pager)
            .find('a')
            .on('click', this.handlePagerClick)
        } else {
          this.$searchResults.append('<li class="no-results">No results</li>')
          this.$searchPager
            .html('')
            .find('a')
            .off('click', this.handlePagerClick)
        }
        this.$searchSpinner.removeClass('is-searching')
        this.currentXhr = null
      })
    }
  }
  handleButtonClick = (event) => {
    this.$searchButton.removeClass('is-selected')
    const $clicked = $(event.target)
    $clicked.addClass('is-selected')
    this.contentType = $clicked.data('contentType')
    if (this.contentType === '') {
      this.contentType = null
    }
    this.doSearch()
  }
  handleClick = () => {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }
  handleDocumentKeyup = (event) => {
    if (event.which === 27) {
      event.preventDefault()
      this.close()
    }
  }
  handleKeyup = () => {
    this.page = 0
    if (this.$searchField.val().length > 2) {
      this.$searchBody.addClass('is-open')
      this.keys = this.$searchField.val()
      this.doSearch()
    } else {
      this.keys = null
      this.$searchResults.html('')
      this.$searchBody.removeClass('is-open')
    }
  }
  handlePagerClick = (event) => {
    event.preventDefault()
    $('.search-body').animate(
      {
        scrollTop: 0,
      },
      200
    )
    const parsed = queryString.parse($(event.currentTarget).attr('href'))
    if (parsed.content_type === '') {
      this.contentType = null
    } else {
      this.contentType = parsed.content_type
    }
    this.keys = parsed.keys
    this.page = parsed.page
    this.doSearch()
  }
  open = () => {
    $(document).on('keyup', this.handleDocumentKeyup)
    this.$searchField.on('keyup', debounce(250, this.handleKeyup))
    this.$searchButton.on('click', this.handleButtonClick)
    $('body').addClass('search-is-open')
    this.$searchContainer.addClass('is-open')
    this.$searchField.focus()
    this.isOpen = true
    this.$searchSpinner.removeClass('is-searching')
    this.trap = focusTrap.createFocusTrap($('.search-trigger').get(0))
    this.trap.activate()
  }
}

export default Search
